const ActionButton = ({
  icon: Icon,
  label,
  onClick,
  className,
  badge,
  styles,
}) => (
  <div className={styles.actionItem}>
    <button className={className} onClick={onClick}>
      <Icon />
      {badge > 0 && <div className={styles.absoluteCircle}>{badge}</div>}
    </button>
    <div className={styles.text}>{label}</div>
  </div>
);

export default ActionButton;
